import { Component } from "@angular/core";
import { NgForm } from "@angular/forms";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PpsUtilityService } from "../services/pps-utility.service";
import { RosterPatternParser } from "../services/roster-pattern-parser";
import { IRosterType } from "../shared/models/roster/roster-type";

@Component({
  selector: 'pps-roster-type-form',
  templateUrl: './roster-type-form.component.html'
})
export class RosterTypeFormComponent{
  originalRosterType: IRosterType;
  rosterType: IRosterType = {
    title: "",
    rosterTypeRule: "",
    rosterTypeDescription: ""
  };
  rosterCodesObj: any = {};
  errorMessage = "";

  constructor(    
    private _dialogRef: DynamicDialogRef,
    private _dlgConfig: DynamicDialogConfig,
    private _parser: RosterPatternParser,
    private _util: PpsUtilityService
  ) {
    this.setData(this._dlgConfig.data);
  }

  setData(data: any){
    data.rosterCodes.forEach(rc => this.rosterCodesObj[rc.code] = rc.id);

    if (data.rosterType){
      this.originalRosterType = data.rosterType;
      this.rosterType = this._util.deepCopy(data.rosterType);
      this._dlgConfig.header = "Update Roster Type";
    }else{
      this._dlgConfig.header = "Create Roster Type";
      this.originalRosterType = this._util.deepCopy(this.rosterType);
    }
  }

  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    var parseResult = this._parser.parse(0, new Date(), this.rosterType.rosterTypeRule, this.rosterCodesObj);
    if (!parseResult.succeed){
      this.errorMessage = parseResult.errors.join(";");
      return false;
    }

    console.log(this.rosterType);
    if (this.originalRosterType.title !== this.rosterType.title ||
      this.originalRosterType.rosterTypeRule !== this.rosterType.rosterTypeRule ||
      this.originalRosterType.rosterTypeDescription !== this.rosterType.rosterTypeDescription){
      this._dialogRef.close(this.rosterType);
    }else{
      this._dialogRef.close();
    }
  }

  cancel(){
    //this.employee.state = this.employee.state.code;
    this._dialogRef.close();
  }
}
